import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import HomeBanner2 from "../ones/HomeBanner2";
import ServicesBanner1 from "../ones/ServicesBanner1";
import data from "../assets/unified.jpg";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>
				<div className="MainBodySection mb-5">
					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<h3 className="main-section-title">
									UNIFIED COMMUNICATION
								</h3>
							</div>

							<div className="col-md-12 bg-surface rounded p-3">
								<h5 className="font-semi-bold text-dim py-3">With the Microsoft Office Communication Server (OCS) 2008 we are there to build all your communication need including instant messaging and e-mail services.</h5>
								<img 
									style={{
										width:"100%",
										height:"auto"
									}}
									src={data} 
								/>
							</div>
						</div>
					</div>
				</div>
				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}